<mat-toolbar [color]="'primary'" id="header" class="toolbar-background">
  <mat-toolbar-row class="flex flex-row mat-toolbar-row">
    <div class="nav-expand mr-16 p-8">
      <mat-icon (click)="menuClicked()" class="icon-md-1 cursor-pointer" [svgIcon]="sidenavService.isExpanded ? 'menu_open' : 'menu'"></mat-icon>
    </div>
    <div class="flex flex-row flex-wrap float-left">
      <div *ngFor="let item of items; let last = last" class="flex flex-row justify-start items-center">
        <mat-icon *ngIf="item.icon" [svgIcon]="item.icon" [routerLink]="['/', tenant]" class="icon-md-1 mr-6 mb-4 breadcrumb-color cursor-pointer"></mat-icon>
        <span *ngIf="!item.url && item.label" class="breadcrumb-color mat-caption mr-8">{{item.label}}</span>
        <a *ngIf="item.url && item.label" [routerLink]="['/', tenant].concat(item.url)"
           class="no-underline mat-caption mr-8">{{item.label}}</a>
        <mat-icon  *ngIf="!last" class="mr-8 icon w-14 h-24" svgIcon="chevron_right"></mat-icon>
      </div>
    </div>
    <span class="example-spacer"></span>
    <div class="flex flex-row justify-center items-center">
      <button (click)="openPlanModal()" *ngIf="hasMySandboxPermission"
              [disabled]="!permissionsMap[Permission.UPGRADE_ENTERPRISE]"
              class="rounded accent mr-14 hidden"
              type="button">{{ 'TOOLBAR.UNLOCK_ENTERPRISE' | transloco }}</button>
      <app-search-filter class="hidden"></app-search-filter>
      <!-- <button (click)="openTenantDashboard()" class="rounded accent mr-14"
              type="button">{{ 'TOOLBAR.TENANT_DASHBOARD' | transloco }}</button> -->
      <mat-icon (click)="onSwitchClick()" class="icon-lg cursor-pointer ml-10 mr-10" svgIcon="cameraswitch" matTooltipClass="form-tooltip left custom-tooltip" [matTooltip]="'ADD_VERSION.SWITCH_TO_TENANT' | transloco"
        matTooltipPosition="{{Constants.POSITION_LEFT}}"></mat-icon>
      <div (click)="openHelpAndSupport()">
        <mat-icon class="icon-lg cursor-pointer ml-10 mr-10" svgIcon="help_outline"></mat-icon>
      </div>
      <mat-icon (click)="bookmarksClick()" class="icon-lg cursor-pointer ml-10" svgIcon="bookmark_border"></mat-icon>

      <!-- <div (click)="openNotifications()">
        <mat-icon class="icon-lg cursor-pointer ml-10 mr-10" svgIcon="notifications"></mat-icon>
      </div> -->
      <app-user-menu></app-user-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<!--
<div class="flex flex-col justify-center items-center toolbar">
  <div class="max-width-lg">
    <div class="flex flex-row justify-between items-center w-100-percent">
      <div class="flex flex-row justify-start items-center">
        <img src="assets/images/temenos-logo.png" class="logo mr-42" [routerLink]="['/', tenant]">
        <div class="mt-2">
          <button class="btn-link mr-32" [routerLink]="['/', tenant]"
            [ngClass]="{'active': ToolbarButton.HOME === activeLink}">
            {{ 'TOOLBAR.HOME' | transloco }}
          </button>
          <button class="btn-link mr-32" [routerLink]="['/', tenant, RouterSegments.TENANTS]"
            [ngClass]="{'active': ToolbarButton.TENANTS === activeLink}">
            {{ 'TOOLBAR.TENANTS' | transloco }}
          </button>
          <button class="btn-link mr-32" [routerLink]="['/', tenant, RouterSegments.COSTMGMT]"
          [ngClass]="{'active': ToolbarButton.COST_MGMT === activeLink}">
          {{ 'TOOLBAR.COST_MGMT' | transloco }}
        </button>
          <button class="btn-link mr-32" [routerLink]="['/', tenant, RouterSegments.INSTANCES]"
            [ngClass]="{'active': ToolbarButton.INSTANCES === activeLink}">
            {{ 'TOOLBAR.INSTANCES' | transloco }}
          </button>
          <button class="btn-link mr-32" [routerLink]="['/', tenant, RouterSegments.SERVICES]"
            [ngClass]="{'active': ToolbarButton.SERVICES === activeLink}">
            {{ 'TOOLBAR.SERVICES' | transloco }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
-->

